import { Form } from 'formik';
import type { FormikProps } from 'formik';
import type { PropsWithChildren } from 'react';

import {
  Button,
  PopoverBody,
  PopoverFooter,
  PopoverButtonGroup,
} from '@frontend/components';

type PopoverBodyFormProps<FormData extends Record<string, unknown>> =
  PropsWithChildren<{
    formikProps: FormikProps<FormData>;
    onClose: () => void;
    isUpdating: boolean;
  }>;

export const TableSettingsForm = <FormData extends Record<string, unknown>>({
  formikProps,
  onClose,
  isUpdating,
  children,
}: PopoverBodyFormProps<FormData>) => {
  const { submitForm, dirty, isSubmitting, resetForm, setSubmitting } =
    formikProps;

  return (
    <Form>
      <PopoverBody
        maxHeight="calc(100vh - 190px - 40px - 8px - 24px)"
        overflowY="auto"
      >
        {children}
      </PopoverBody>
      <PopoverFooter>
        <PopoverButtonGroup>
          <Button
            variant={'secondary'}
            onClick={() => {
              resetForm();
              setSubmitting(false);
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant={'primary'}
            isDisabled={!dirty || isSubmitting || isUpdating}
            isLoading={isUpdating}
            onClick={submitForm}
          >
            Save Changes
          </Button>
        </PopoverButtonGroup>
      </PopoverFooter>
    </Form>
  );
};
